<template>
    <vue-scroll>
        <el-form>
            <el-form-item label="Headline">
                <el-input v-model="form.headline" />
            </el-form-item>
            <el-form-item class="mb-0" label="Body Text"> </el-form-item>
            <div id="toolbar">
                <!-- <div class="d-inline-block">
                                <a class="text" @click="stack()">stack</a>
                            </div> -->
                <div class="d-inline-block">
                    <button @click.prevent="undo()" class="undo" title="Undo">
                        <svg viewbox="0 0 18 18">
                            <polygon
                                class="ql-fill ql-stroke"
                                points="6 10 4 12 2 10 6 10"
                            />
                            <path
                                class="ql-stroke"
                                d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
                            />
                        </svg>
                    </button>
                    <a class="text" @click="undo()">Undo</a>
                </div>
                <div class="d-inline-block">
                    <button @click.prevent="redo()" class="redo" title="Redo">
                        <svg viewbox="0 0 18 18">
                            <polygon
                                class="ql-fill ql-stroke"
                                points="12 10 14 12 16 10 12 10"
                            />
                            <path
                                class="ql-stroke"
                                d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"
                            />
                        </svg>
                    </button>
                    <a class="text" @click="redo()">Redo</a>
                </div>
                <div class="d-inline-block">
                    <button
                        class="ql-check"
                        title="Check Spelling and Grammar"
                        @click.prevent="checkspelling()"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 576 512"
                        >
                            <path
                                fill="#ff6a6a"
                                d="M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L66.7 224l90.7 0 5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0zm18.7 160l-37.3 0L112 115.2 130.7 160zM256 32l0 96 0 96c0 17.7 14.3 32 32 32l80 0c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80L288 0c-17.7 0-32 14.3-32 32zm96 64l-32 0 0-32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0-32zM566.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"
                            />
                        </svg>
                    </button>
                    <a class="text" @click="checkspelling()"
                        >Check Spelling and Grammar</a
                    >
                </div>
            </div>
            <div ref="editor" id="editor"></div>
            <div class="float-right mt-20">
                <el-button
                    type="primary"
                    icon="mdi mdi-content-save"
                    :loading="form.busy"
                    @click="submit()"
                    >{{ fillerArticle ? "Save Changes" : "Create" }}
                </el-button>
            </div>
            <div class="clearfix"></div>
        </el-form>
    </vue-scroll>
</template>

<script>
import ImageBlot from "@/plugins/quill";
import QuillHistory from "@/plugins/quill-history";
import {
    getCleanedHtml,
    default as registerQuillLanguageTool
} from "@/plugins/quill-languagetool/index.es";
import _Quill from "quill";
import * as Routes from "../../../constants/routes";
const Quill = window.Quill || _Quill;
const Delta = Quill.import("delta");

export default {
    props: {
        fillerArticle: {
            type: Object
        }
    },
    data() {
        return {
            form: new Form({
                headline: null,
                body: null
            }),
            editor: null
        };
    },
    mounted() {
        if (this.fillerArticle) {
            _.extend(
                this.form,
                _.pick(this.fillerArticle, ["headline", "body"])
            );
        }
        this.initEditor();
    },
    computed: {},
    methods: {
        initEditor() {
            let self = this;
            Vue.nextTick(() => {
                ImageBlot.blotName = "image";
                ImageBlot.tagName = "img";
                Quill.register(ImageBlot);
                registerQuillLanguageTool(Quill);
                Quill.register("modules/history", QuillHistory, true);
                this.editor = new Quill(this.$refs.editor, {
                    formats: ["image", "ltmatch"],
                    modules: {
                        toolbar: {
                            container: "#toolbar",
                            handlers: {
                                image() {
                                    self.uploadDialogVisible = true;
                                }
                            }
                        },
                        history: {
                            delay: 2000,
                            maxStack: 500,
                            userOnly: true
                        },
                        languageTool: {
                            server: process.env.MIX_LANGUAGETOOL_SERVER_URL,
                            cooldownTime:
                                process.env.MIX_LANGUAGETOOL_COOLDOWNTIME,
                            apiOptions: {
                                level: "default",
                                language: "auto",
                                preferredVariants: "en-US"
                            }
                        },
                        clipboard: {
                            matchers: [
                                [
                                    Node.ELEMENT_NODE,
                                    function (node, delta) {
                                        console.debug("matcher, input", {
                                            node: node,
                                            delta: delta
                                        });
                                        var plaintext = $(node).text();
                                        var result = new Delta().insert(
                                            plaintext
                                        );
                                        console.debug("matcher, output", {
                                            delta: result
                                        });
                                        return result;
                                    }
                                ]
                            ]
                        }
                    },
                    placeholder: "Enter filler article body here...",
                    readOnly: false,
                    theme: "snow"
                });
                this.editor.root.innerHTML = getCleanedHtml(this.form.body);
            });
        },
        submit() {
            this.closePopup();
            this.form.body = getCleanedHtml(this.editor.root.innerHTML);
            if (this.fillerArticle) {
                window.App.put(
                    `/web-api/filler-article/${this.fillerArticle.id}`,
                    this.form
                ).then(() => {
                    this.$notify.success({
                        message: "Changes have been saved."
                    });
                    this.$router.push({
                        name: Routes.FILLER_ARTICLES
                    });
                });
            } else {
                window.App.post(`/web-api/filler-article`, this.form).then(
                    () => {
                        this.$notify.success({
                            message: "New filler article has been created."
                        });
                        this.$router.push({
                            name: Routes.FILLER_ARTICLES
                        });
                    }
                );
            }
        },
        checkspelling() {
            this.closePopup();
            this.editor.getModule("languageTool").checkSpelling();
        },
        closePopup() {
            this.editor.getModule("languageTool").popups.closePopup();
        },
        undo() {
            console.log("undo", this.editor.history.stack);
            this.editor.history.undo();
        },
        redo() {
            console.log("redo", this.editor.history.stack);
            this.editor.history.redo();
        },
        stack() {
            console.log("stack", this.editor.history.stack);
        }
    }
};
</script>

<style>
.cke {
    display: none !important;
}
@import "https://cdn.quilljs.com/1.3.6/quill.snow.css";
@import "https://cdn.quilljs.com/1.3.6/quill.bubble.css";
@import "../../../../sass/components/quill.scss";
</style>

<style scoped>
.text {
    font-size: 15px;
    line-height: 17px;
    color: #4a596a;
    vertical-align: text-top;
    text-decoration: none;
}
</style>
